export default "__VITE_ASSET__39991460__"